import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Disenos extends Component {
    constructor(props){
        super(props);
        this.state = {
            prodAll: []
        }
        fetch('http://ebenlovequickpc.com/API/producto.php?cl=dis')
        .then((response => response.json()))
        .then((json) => {
            this.setState({
                prodAll: json
            });
        });
    }
  render() {
    return (
        <div className="w3-container">
            <h5>Diseños <Link to={`/disenos/0`} className="w3-button w3-tiny w3-blue w3-border-blue w3-border w3-round-large" style={{marginLeft: '17px'}}>Agregar diseños</Link></h5>
            <table className="w3-table-all">
                <thead>
                    <tr className='w3-black'>
                        <th>Codigo</th>
                        <th>Nombre</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                        <th>Precio</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    { this.state.prodAll.map((v, i) => {
                        return (
                        <tr key={v.CODIGO_ART}>
                            <th>{v.CODIGO_ART}</th>
                            <td>{v.MARCA}</td>
                            <td>{v.TIPO}</td>
                            <td>{v.DESCR}</td>
                            <td>${v.PRECIO}</td>
                            <td><Link to={`/disenos/${v.CODIGO_ART}`} className="w3-button w3-tiny  w3-border w3-round-large" style={{marginRight: '7px'}}>Ver</Link></td>
                        </tr>
                        )
                        }) }
                </tbody>
            </table>
      </div>
    );
  }
}

export default Disenos;


// WEBPACK FOOTER //
// ./src/Servicios/Disenos.js